export default __webpack_public_path__ + "static/media/assemblyLogoFull.ad8bcfee.svg";